import React from 'react'
import { Flex } from 'uikit'
import { Token } from 'config/constants/types'
import { getAddress } from 'utils/addressHelpers'

interface LpTokenImageProps {
  token: Token
  quoteToken: Token
  height?: number
}

const LpTokenImage: React.FC<LpTokenImageProps> = ({ token, quoteToken, height = 38 }) => {
  let margin = -12
  if (height > 38) {
    margin = -14
  } else if (height < 38) {
    margin = -6
  }

  return (
    <Flex>
      <img
        src={`/images/tokens/${getAddress(token.address)}.png`}
        alt={`${getAddress(token.address)}.png`}
        width={height}
        height={height}
      />
      <img
        src={`/images/tokens/${getAddress(quoteToken.address)}.png`}
        alt={`${getAddress(quoteToken.address)}.png`}
        width={height}
        height={height}
        style={{ marginLeft: `${margin}px` }}
      />
    </Flex>
  )
}

export default LpTokenImage
